<app-header></app-header>
<app-botao-chat></app-botao-chat>
<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>

<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">

        <div class="row">
          <div class="col-lg-12">
            <app-breadcrumb></app-breadcrumb>
            <h1 class="titulo">Condições de contratação </h1>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-5">
            <span class="texto-titulo">Taxa de Serviço </span>
            @for (s of resources?.taxaServico; track s) {
              <p class="subtitulo-alert ">{{s}}</p>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-5">
            <span class="texto-titulo ">Taxa de Atendimento</span>
            @for (a of resources?.taxaEntrega; track a) {
              <p class="subtitulo-alert ">{{a}}</p>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-5">
            <span class="texto-titulo ">Taxa de Processamento</span>
            @for (p of resources?.taxaProcessamentoCartao; track p) {
              <p class="subtitulo-alert ">{{p}}
              </p>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 mt-5 mb-3">
            <span class="texto-titulo ">Taxa Recarga Certa</span>
            @for (r of resources?.taxaRecargaCerta; track r) {
              <p class="subtitulo-alert ">{{r}}</p>
            }
          </div>
        </div>


        <hr>

          <div class="row">
            <div class="col-lg-12 mt-4">
              <span class="texto-titulo c-black">PRAZOS OPERACIONAIS</span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 mt-2">
              @if (html) {
                <section class="content" [innerHTML]="html"></section>
              }
            </div>
          </div>



          <div class="mb-2 mt-5 text-center ">
            <a target="_blank" type="button " class="btn btn-borda-verde bnt-font btn-grande me-4"
              (click)="downloadContratos()">
              Download do contrato
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-footer></app-footer>
